"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
var _default = exports.default = _styledComponents.default.div.withConfig({
  componentId: "sc-1c02fiw-0"
})(["margin-left:32px;&.user-icon{border:none;padding-left:0px;margin-left:16px;margin-right:0px;}@media ", "{height:48x;margin-left:24px;&.user-icon{border-left:2px solid #D6D6DE;padding-left:24px;margin-left:20px;margin-right:24px;}}"], _responsive.default.lg);